import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import commonFunction from "../../Utils/commonFunction";
import "./Forgotpassword.css";

function Forgotpassword() {
    const navigate = useNavigate();
    const validationSchema = yup.object({
        email: yup.string().email("Ugyldig Email").required("E-mail er påkrævet."),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
        },

        onSubmit: async (values) => {
            try {
                const response = await commonFunction.sendOtp(values);
                if (response.status === 200) {
                    toast.success(response.data.message, { autoClose: 7000 });
                    formik.resetForm();
                    navigate("/reset-password", {
                        state: {
                            email: values.email,
                        },
                    });
                }
            } catch (error) {
                // toast.error(error?.response?.message ?? "Please wait!! Something went wrong !!");
            } finally {
                navigate("/reset-password", {
                    state: {
                        email: values.email,
                    },
                });
            }
        },
        validationSchema,
    });

    return (
        <>
            <main>
                <section className="login-sec wow pulse">
                    <div className="container">
                        <div className="login-inner">
                            <div className="row">
                                <div className="col-md-6">
                                    <form
                                        className="form_elements forgot-password-form"
                                        onSubmit={formik.handleSubmit}
                                    >
                                        {/* Heading + Instructions */}
                                        <div className="form-title forgot-password-title">
                                            <h2>Glemt adgangskode</h2>

                                            <ul className="forgot-password-info">
                                                <li>
                                                    Indtast din e-mail for at få en
                                                    engangsadgangskode.
                                                </li>

                                                <li>
                                                    Tjek spam eller uønsket post, hvis
                                                    mailen ikke ligger i indbakken.
                                                </li>

                                                <li>
                                                    Ligger mailen der, så flyt den til
                                                    indbakken, så fremtidige mails også
                                                    kommer i indbakken.
                                                </li>
                                            </ul>
                                        </div>

                                        {/* Email */}
                                        <div className="form-group forgot-email-group">
                                            <div className="label_wrap forgot-email-label">
                                                <label htmlFor="email">
                                                    Email ID
                                                </label>
                                                <abbr>*</abbr>
                                            </div>

                                            <input
                                                type="email"
                                                className={`form-control forgot-email-input ${formik.touched.email && formik.errors.email ? "input-error" : ""}`}
                                                id="email"
                                                name="email"
                                                placeholder="Indtast Email for at få engangsadgangskoden"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.email}
                                            />
                                            {formik.touched.email && formik.errors.email ? (
                                                <div className="error-message">
                                                    <span className="error-icon">!</span>
                                                    <span>{formik.errors.email}</span>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="btn_submit forgot-password-submit">
                                            <button
                                                type="submit"
                                                className="btn btn-1 w-100"
                                                disabled={formik.isSubmitting}
                                                style={{ fontSize: '16px' }}
                                            >
                                                Få tilsendt engangskode
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-6">
                                    <div className="reset-img">
                                        {/* Your other content goes here */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}

export default Forgotpassword;
